<div (click)="onClick()" class="clickable">
  <mat-icon class="icon">notifications</mat-icon>
  <div class="message-container">
    <span class="message">{{ data?.message?.notification?.title }}</span>
    <span class="description">{{ data?.message?.notification?.body }}</span>
  </div>
  <mat-icon class="close-icon" (click)="close($event)" class="icon">close</mat-icon>
</div>